export const BgColors = [
    'zapier',
    'night',
    'moss',
    'neutral800',
    'neutral100',
    'earth',
];
export const BgColorMap = {
    lava60: 'zapier',
    ocean40: 'night',
    sun60: 'moss',
    white: 'neutral100',
};
export const TextColorMap = {
    zapier: 'cream',
    neutral100: 'neutral800',
    night: 'neutral100',
    moss: 'neutral100',
    neutral800: 'neutral100',
    earth: 'neutral100',
};
//# sourceMappingURL=constants.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
